import axios from "axios";
import appConfig from "../config/appConfig";
import { verifyPermission } from "../helpers/permission";

export const createEndpoints = (plan, userPermissions) => {
  const endpoints = {
    PRO: {
      list: `${appConfig.apiDomaine}/my/units`,
      destroy: (unitId) => `${appConfig.apiDomaine}/my/units/${unitId}`,
    },
    MACRO: {
      holding: {
        list: `${appConfig.apiDomaine}/any/units`,
        destroy: (unitId) => `${appConfig.apiDomaine}/any/units/${unitId}`,
      },
      filial: {
        list: `${appConfig.apiDomaine}/my/units`,
        destroy: (unitId) => `${appConfig.apiDomaine}/my/units/${unitId}`,
      },
    },
    HUB: {
      list: `${appConfig.apiDomaine}/without-link/units`,
      destroy: (unitId) =>
        `${appConfig.apiDomaine}/without-link/units/${unitId}`,
    },
  };

  let endPoint = "";
  if (plan === "MACRO") {
    if (verifyPermission(userPermissions, "list-any-unit"))
      endPoint = endpoints[plan].holding;
    else if (verifyPermission(userPermissions, "list-my-unit"))
      endPoint = endpoints[plan].filial;
  } else {
    endPoint = endpoints[plan];
  }

  return endPoint;
};

export const fetchUnits = async (endPoint) => {
  try {
    const response = await axios.get(endPoint.list);
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const deleteUnit = async (endPoint, unitId) => {
  try {
    const response = await axios.delete(endPoint.destroy(unitId));
    return response.data;
  } catch (error) {
    throw error;
  }
};
